import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './quick-subscribe-desktop.css';
import './quick-subscribe-mobile.css';
import './subscribe-desktop.css';
import './subscribe-mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { config } from './utility';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

config.cookie = getCookie("XSRF-TOKEN");

switch (window.location.origin) {
  case 'https://ws.validsolutions.net':
    config.baseUrl = 'https://ws.validsolutions.net/traderjoes/fearlessflyer';
    break;
  case 'https://vdsweb1-ws.validsolutions.net':
    config.baseUrl = 'https://vdsweb1-ws.validsolutions.net/traderjoes/fearlessflyer';
    break;
  case 'https://vdsweb2-ws.validsolutions.net':
    config.baseUrl = 'https://vdsweb2-ws.validsolutions.net/traderjoes/fearlessflyer';
    break;
  case 'https://ws.veritedata.net':
    config.baseUrl = 'https://ws.veritedata.net/traderjoes/fearlessflyer';
    break;
  case 'https://vdsweb1-ws.veritedata.net':
    config.baseUrl = 'https://vdsweb1-ws.veritedata.net/traderjoes/fearlessflyer';
    break;
  case 'https://vdsweb2-ws.veritedata.net':
    config.baseUrl = 'https://vdsweb2-ws.veritedata.net/traderjoes/fearlessflyer';
    break;
  case 'https://vdsiisinternal.validusa.com':
    config.baseUrl = 'https://vdsiisinternal.validusa.com/traderjoes/fearlessflyer';
    break;
  default:
    config.baseUrl = window.location.origin;
}

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
